import axios from 'axios'

export const GetActivities = (resolve, reject) => {
    const getUrl = "./api/SampleData/getActivities"

    axios.get(getUrl).then(result => {
        resolve(result.data)
    }).catch((err) => {
        reject(err)
    })
}


// WEBPACK FOOTER //
// ./src/components/services/getActivities.js